import React, { useEffect, useState } from "react";
import ModalFiltering from "../../../Components/FormElements/ModalFiltering";
import Button from "../../../Components/FormElements/Button";
import InputNumber from "../../../Components/inputNumber";
import IconClose from "../../../Resources/svg/Icons/IconClose";
import { useForm } from "react-hook-form";
import ErrorCustom from "../../../Components/errorCustom";
import useAverageRemuneration from "../../../Components/hooks/useAverageRemuneration";

const ModalEditRem = ({ openModalEditRem, setOpenModalEditRem, request }) => {
  const [loadingState, setLoadingState] = useState(false);
  const [requestState, setRequestState] = useState();

  const {
    handleSubmit,
    register,
    errors,
    setValue,
  } = useForm();

  const { patchAverageRemuneration } = useAverageRemuneration({ setOpenModalEditRem });

  const sendRemProm = async (values) => {
    setLoadingState(true);
    const { remuneracionPromedio } = values;
    const payload = {
      payload: {
        id: String(requestState.nroOperacion),
        remuneracionPromedio: remuneracionPromedio,
      },
    };
    await patchAverageRemuneration(payload);
    setLoadingState(false);
  };

  useEffect(() => {
    if (request) {
      setRequestState(request);
    }
  }, [request]);

  return (
    <ModalFiltering
      className={`modal-result is-midle update-rem ${
        openModalEditRem && "is-open"
      }`}
      variant={true}
    >
      <div
        className="modal-filtering__close"
        onClick={() => setOpenModalEditRem(false)}
      >
        <IconClose />
      </div>
      <h2 className="modal-result__title">Ingresar Remuneración Promedio</h2>
      <div>
        <form onSubmit={handleSubmit(sendRemProm)} className="clientForm">
          <div className="card-verify__body">
            <div className="card-verify__quote">CUSSP del asegurado: </div>
            <div className="card-verify__data">{request.CUSPP}</div>
          </div>
          <div className="card-verify__body">
            <div className="card-verify__quote">Moneda de Remuneración: </div>
            <div className="card-verify__data">S/.</div>
          </div>
          <div className="vasForm__form__input-container-select">
            <label>Remuneración Promedio</label>
            <InputNumber
              nameVal="remuneracionPromedio"
              setValue={setValue}
              register={register}
              thousandSeparator={","}
              allowNegative={true}
              validatorInput={(value) => {}}
              init={0}
            />
            <ErrorCustom errors={errors} name="remuneracionPromedio" />
          </div>

          <div className="actions">
            <Button type="submit" className={`btn is-primary ${loadingState ? "is-loading is-disabled" : ""} actions__cancel`}>
              Guardar
            </Button>
          </div>
        </form>
      </div>
    </ModalFiltering>
  );
};


export default ModalEditRem;
